export { default as A11ExaminationDetails } from "./examinationDetails";
export { default as A11Opinion } from "./opinion";
export { default as A11PatientDetails } from "./patientDetails";
export { default as A11Reasons } from "./reasons";
export { default as A11DoctorDetails } from "./doctorDetails";
